import { makeAutoObservable } from 'mobx';
import {CookieValueTypes, deleteCookie, getCookie, hasCookie} from 'cookies-next';

export class UserStore {
    USERNAME: string | Promise<CookieValueTypes> = '';
    USERROLE: string | Promise<CookieValueTypes> = '';
    private intervalId: NodeJS.Timeout | null = null;

    constructor() {
        makeAutoObservable(this);

        this.USERNAME = getCookie('username') ?? '';
        this.USERROLE = getCookie('userrole') ?? '';
    }

    setUserName = (value: string) => {
        this.USERNAME = value;
    };
    setUserRole = (value: string) => {
        this.USERROLE = value;
    };
    clearUser = () => {
        this.USERNAME = '';
        this.USERROLE = '';
    };

    logout = async () => {
        const cookies = ['accessToken', 'refreshToken', 'refreshExpiresIn', 'expiresIn', 'role']

        cookies.forEach(key => {
            deleteCookie(key);
        })

        if (!cookies.some(key => hasCookie(key))) {
            this.clearUser();

            return true;
        }
        return false;
    }

    private clearTokenInterval = () => {
        if (this.intervalId) {
            clearTimeout(this.intervalId);
            this.intervalId = null;
        }
    };
    setTokenExpirationInterval = (expirationTime: number) => {
        this.clearTokenInterval();

        const timeToDeauthorize = expirationTime - Date.now();
        if (timeToDeauthorize > 0) {
            this.intervalId = setTimeout(() => {
                this.logout();
            }, timeToDeauthorize);
        } else {
            this.logout();
        }
    };
}
